import { Injectable, inject } from '@angular/core';
import { SupabaseClient } from '@supabase/supabase-js';
import { CoinRecord } from '@app/model/coin-record';
import { SUPABASE_CLIENT } from '@app/providers/supabase.provider';

@Injectable({
  providedIn: 'root'
})
export class CoinRecordService {

  coinRecord: CoinRecord = new CoinRecord('', new Date(), '', '', '', 0);
  private supabaseClient: SupabaseClient;

  constructor() {
    this.supabaseClient = inject(SUPABASE_CLIENT);
  }

  async getAllCoinRecord() {
    const res = await this.supabaseClient
      .from('coin_record')
      .select('*')
      .order('created_at', { ascending: false });
    return res?.data;
  }

  async getCoinRecordsByUserId(userId: string) {
    const res = await this.supabaseClient
      .from('coin_record')
      .select('*')
      .or(`sent_from.eq.${userId},sent_to.eq.${userId}`)
      .order('created_at', { ascending: false });
    return res?.data;
  }

  async getCoinRecordsByUserIdForSentFrom(userId: string) {
    const res = await this.supabaseClient
      .from('coin_record')
      .select('*')
      .eq('sent_from', userId)
      .order('created_at', { ascending: false });
    return res?.data;
  }

  async getCoinRecordsByUserIdForSentTo(userId: string) {
    const res = await this.supabaseClient
      .from('coin_record')
      .select('*')
      .eq('sent_to', userId)
      .order('created_at', { ascending: false });
    return res?.data;
  }

  async undoCoinRecord(coinRecordId: string) {
    const { data, error } = await this.supabaseClient.rpc('undo_coin_record', {
      target_coin_record_id: coinRecordId
    });

    if (error) {
      throw error;
    }

    return data;
  }

}
